import React from "react";
import PropTypes from 'prop-types'

import AccordionContext from "../AccordionContext";
import AccordionItemContext from "./AccordionItemContext";

import { generateClassString } from "../../../lib/helper/generateClassString";

import * as styles from './component.module.less'

function AccordionItem({ className, eventKey, children }) {
    const { activeItem } = React.useContext(AccordionContext);
    const isActive = activeItem === eventKey;

    return (
        <AccordionItemContext.Provider value={{ eventKey }}>
            <div
                className={generateClassString(className, styles.accordionItem, [
                    isActive,
                    styles.active
                ])}
            >
                {children}
            </div>
        </AccordionItemContext.Provider>
    );
}

AccordionItem.propTypes = {
    eventKey: PropTypes.string.isRequired
}

export default AccordionItem